module.exports = __webpack_public_path__ + "static/img/logo.3a9064f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 25